import React from 'react';
import PropTypes from 'prop-types';
import Table from './Table';

const ResponsiveTable = ({children, htmlId}) => {
    return(
        <div className="col-xs-12 table-responsive">
            <Table
                className="table table-hover"
                id={htmlId}>
                {children}
            </Table>
        </div>
    );
};

ResponsiveTable.propTypes = {
    children: PropTypes.node,
    htmlId: PropTypes.string
};

export default ResponsiveTable;


// WEBPACK FOOTER //
// ./src/components/base/Table/ResponsiveTable.js